var _regeneratorRuntime = require("/var/www/html/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/var/www/html/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var _possibleConstructorReturn = require("/var/www/html/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/var/www/html/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _inherits = require("/var/www/html/node_modules/@babel/runtime/helpers/inherits.js");
var _createClass = require("/var/www/html/node_modules/@babel/runtime/helpers/createClass.js");
var _classCallCheck = require("/var/www/html/node_modules/@babel/runtime/helpers/classCallCheck.js");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
!function (t, e) {
  for (var n in e) t[n] = e[n];
}(exports, function (t) {
  var e = {},
    n = {
      0: 0
    };
  function i(n) {
    if (e[n]) return e[n].exports;
    var r = e[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return t[n].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
  }
  return i.e = function (e) {
    if (0 !== n[e]) {
      var i = require("./" + e + "." + {
          1: "a9e9bb9bc3fb985b2d88"
        }[e] + ".js"),
        r = i.modules,
        a = i.ids;
      for (var s in r) t[s] = r[s];
      for (var o = 0; o < a.length; o++) n[a[o]] = 0;
    }
    return Promise.all([]);
  }, i.m = t, i.c = e, i.d = function (t, e, n) {
    i.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: n
    });
  }, i.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, i.t = function (t, e) {
    if (1 & e && (t = i(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var n = Object.create(null);
    if (i.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var r in t) i.d(n, r, function (e) {
      return t[e];
    }.bind(null, r));
    return n;
  }, i.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return i.d(e, "a", e), e;
  }, i.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, i.p = "", i.oe = function (t) {
    process.nextTick(function () {
      throw t;
    });
  }, i(i.s = 5);
}([function (t, e, n) {
  "use strict";

  n.d(e, "a", function () {
    return i;
  });
  var i = /*#__PURE__*/_createClass(function i() {
    _classCallCheck(this, i);
  });
}, function (t, e) {
  t.exports = "[object process]" === Object.prototype.toString.call("undefined" != typeof process ? process : 0);
}, function (t, e) {
  t.exports = require("form-data");
}, function (t, e, n) {
  "use strict";

  n.r(e), n.d(e, "default", function () {
    return a;
  });
  var i = n(0),
    r = n(2);
  var a = /*#__PURE__*/function (_i$a) {
    function a() {
      _classCallCheck(this, a);
      return _callSuper(this, a, arguments);
    }
    _inherits(a, _i$a);
    return _createClass(a, [{
      key: "fetch",
      value: function () {
        var _fetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t, e) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this.fFetch;
                if (_context.t0) {
                  _context.next = 5;
                  break;
                }
                _context.next = 4;
                return n.e(1).then(n.bind(null, 6));
              case 4:
                this.fFetch = _context.sent.default;
              case 5:
                return _context.abrupt("return", this.fFetch(t, e));
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function fetch(_x, _x2) {
          return _fetch.apply(this, arguments);
        }
        return fetch;
      }()
    }, {
      key: "FormData",
      get: function get() {
        return r;
      }
    }]);
  }(i.a);
}, function (t, e, n) {
  "use strict";

  n.r(e), n.d(e, "default", function () {
    return r;
  });
  var i = n(0);
  var r = /*#__PURE__*/function (_i$a2) {
    function r() {
      _classCallCheck(this, r);
      return _callSuper(this, r, arguments);
    }
    _inherits(r, _i$a2);
    return _createClass(r, [{
      key: "fetch",
      value: function () {
        var _fetch2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t, e) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", window.fetch(t, e));
              case 1:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function fetch(_x3, _x4) {
          return _fetch2.apply(this, arguments);
        }
        return fetch;
      }()
    }, {
      key: "FormData",
      get: function get() {
        return FormData;
      }
    }]);
  }(i.a);
}, function (t, e, n) {
  "use strict";

  var i;
  n.r(e);
  var r = i = n(1) ? new (0, n(3).default)() : new (0, n(4).default)();
  var a = /*#__PURE__*/function () {
    function a() {
      _classCallCheck(this, a);
      this.delayCalls = Promise.resolve();
    }
    return _createClass(a, [{
      key: "setConfiguration",
      value: function setConfiguration(t) {
        this.fConfigurationData = t;
      }
    }, {
      key: "post",
      value: function () {
        var _post = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t, e) {
          var n,
            i,
            _args3 = arguments;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                n = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
                i = "".concat(this.fConfigurationData.ARCADE_SERVER).concat(t);
                return _context3.abrupt("return", new Promise(function (t, _a) {
                  var s = r.fetch(i, {
                    headers: n,
                    body: e,
                    method: "POST"
                  });
                  s.catch(_a), t(s);
                }));
              case 3:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this);
        }));
        function post(_x5, _x6) {
          return _post.apply(this, arguments);
        }
        return post;
      }()
    }]);
  }();
  var s = 5e3;
  var o = /*#__PURE__*/function (_a2) {
    function o() {
      var _this;
      _classCallCheck(this, o);
      _this = _callSuper(this, o, arguments), _this.fAuthenticationData = null, _this.fExpireDate = Date.now() - 1e3, _this.fRequestingAuthenticationPromise = null, _this.fAuthInProgress = !1;
      return _this;
    }
    _inherits(o, _a2);
    return _createClass(o, [{
      key: "updateAuthenticationData",
      value: function () {
        var _updateAuthenticationData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
          var _this2 = this;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(t, e) {
                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.prev = 0;
                          if (!_this2.fAuthInProgress) {
                            _context4.next = 7;
                            break;
                          }
                          _context4.next = 4;
                          return _this2.fRequestingAuthenticationPromise;
                        case 4:
                          _this2.fAuthenticationData = _context4.sent;
                          _context4.next = 10;
                          break;
                        case 7:
                          _context4.next = 9;
                          return _this2.requestAuthentication();
                        case 9:
                          _this2.fAuthenticationData = _context4.sent;
                        case 10:
                          _this2.updateExpirity();
                          t();
                          _context4.next = 17;
                          break;
                        case 14:
                          _context4.prev = 14;
                          _context4.t0 = _context4["catch"](0);
                          e(_context4.t0);
                        case 17:
                        case "end":
                          return _context4.stop();
                      }
                    }, _callee4, null, [[0, 14]]);
                  }));
                  return function (_x7, _x8) {
                    return _ref.apply(this, arguments);
                  };
                }()));
              case 1:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        function updateAuthenticationData() {
          return _updateAuthenticationData.apply(this, arguments);
        }
        return updateAuthenticationData;
      }()
    }, {
      key: "updateExpirity",
      value: function updateExpirity() {
        this.fExpireDate = Date.now() + (1e3 * this.fAuthenticationData.expires_in - s);
      }
    }, {
      key: "isAuthenticationExpired",
      value: function isAuthenticationExpired() {
        return this.fExpireDate <= Date.now();
      }
    }, {
      key: "ensureAuthentication",
      value: function () {
        var _ensureAuthentication = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(t) {
          var _this3 = this;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e) {
                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) switch (_context6.prev = _context6.next) {
                        case 0:
                          _context6.prev = 0;
                          _context6.t0 = _this3.isAuthenticationExpired();
                          if (!_context6.t0) {
                            _context6.next = 5;
                            break;
                          }
                          _context6.next = 5;
                          return _this3.updateAuthenticationData();
                        case 5:
                          _context6.next = 10;
                          break;
                        case 7:
                          _context6.prev = 7;
                          _context6.t1 = _context6["catch"](0);
                          t(_context6.t1);
                        case 10:
                          _context6.prev = 10;
                          e();
                          return _context6.finish(10);
                        case 13:
                        case "end":
                          return _context6.stop();
                      }
                    }, _callee6, null, [[0, 7, 10, 13]]);
                  }));
                  return function (_x10) {
                    return _ref2.apply(this, arguments);
                  };
                }()));
              case 1:
              case "end":
                return _context7.stop();
            }
          }, _callee7);
        }));
        function ensureAuthentication(_x9) {
          return _ensureAuthentication.apply(this, arguments);
        }
        return ensureAuthentication;
      }()
    }, {
      key: "requestAuthentication",
      value: function () {
        var _requestAuthentication = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
          var _this4 = this;
          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(t, e) {
                    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                      while (1) switch (_context9.prev = _context9.next) {
                        case 0:
                          if (!_this4.fAuthInProgress) {
                            _context9.next = 4;
                            break;
                          }
                          _context9.next = 3;
                          return _this4.fRequestingAuthenticationPromise;
                        case 3:
                          return _context9.abrupt("return", t(_this4.fAuthenticationData));
                        case 4:
                          _context9.next = 6;
                          return _this4.delayCalls;
                        case 6:
                          _this4.fAuthInProgress = !0;
                          _this4.fRequestingAuthenticationPromise = new Promise( /*#__PURE__*/function () {
                            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(n) {
                              var i, a, _e, _r;
                              return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                                while (1) switch (_context8.prev = _context8.next) {
                                  case 0:
                                    a = new r.FormData();
                                    a.append("grant_type", "client_credentials"), a.append("client_id", _this4.fConfigurationData.ARCADE_CLIENT_ID), a.append("client_secret", _this4.fConfigurationData.ARCADE_CLIENT_SECRET);
                                    _context8.prev = 2;
                                    _context8.next = 5;
                                    return _this4.post("".concat((i = _this4.fConfigurationData.ARCADE_API_PATH, null != i ? i : ""), "/OAuth/index.php"), a);
                                  case 5:
                                    _e = _context8.sent;
                                    _context8.next = 8;
                                    return _e.json();
                                  case 8:
                                    _r = _context8.sent;
                                    if (!_r.error) {
                                      _context8.next = 11;
                                      break;
                                    }
                                    throw new Error("\n\nArcade responded with an Error: \n ".concat(_r.error));
                                  case 11:
                                    n(_r), t(_r), _this4.fAuthInProgress = !1;
                                    _context8.next = 17;
                                    break;
                                  case 14:
                                    _context8.prev = 14;
                                    _context8.t0 = _context8["catch"](2);
                                    e(_context8.t0);
                                  case 17:
                                  case "end":
                                    return _context8.stop();
                                }
                              }, _callee8, null, [[2, 14]]);
                            }));
                            return function (_x13) {
                              return _ref4.apply(this, arguments);
                            };
                          }());
                        case 8:
                        case "end":
                          return _context9.stop();
                      }
                    }, _callee9);
                  }));
                  return function (_x11, _x12) {
                    return _ref3.apply(this, arguments);
                  };
                }()));
              case 1:
              case "end":
                return _context10.stop();
            }
          }, _callee10);
        }));
        function requestAuthentication() {
          return _requestAuthentication.apply(this, arguments);
        }
        return requestAuthentication;
      }()
    }]);
  }(a);
  var c = /*#__PURE__*/function (_o) {
    function c() {
      _classCallCheck(this, c);
      return _callSuper(this, c, arguments);
    }
    _inherits(c, _o);
    return _createClass(c, [{
      key: "saveInspectionResults",
      value: function () {
        var _saveInspectionResults = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(t) {
          return _regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", this.invokeArcadeAction("SaveInspectionResults", {
                  url: t.link,
                  passed: t.result,
                  additional_data: JSON.stringify(t.rawData),
                  type: t.type,
                  geo: t.geo
                }));
              case 1:
              case "end":
                return _context11.stop();
            }
          }, _callee11, this);
        }));
        function saveInspectionResults(_x14) {
          return _saveInspectionResults.apply(this, arguments);
        }
        return saveInspectionResults;
      }()
    }, {
      key: "getInspectionResults",
      value: function () {
        var _getInspectionResults = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(t) {
          return _regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", this.invokeArcadeAction("GetInspectionResults", t));
              case 1:
              case "end":
                return _context12.stop();
            }
          }, _callee12, this);
        }));
        function getInspectionResults(_x15) {
          return _getInspectionResults.apply(this, arguments);
        }
        return getInspectionResults;
      }()
    }, {
      key: "getInspectionResultsByDate",
      value: function () {
        var _getInspectionResultsByDate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(t) {
          return _regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", this.invokeArcadeAction("GetInspectionResultsByDate", t));
              case 1:
              case "end":
                return _context13.stop();
            }
          }, _callee13, this);
        }));
        function getInspectionResultsByDate(_x16) {
          return _getInspectionResultsByDate.apply(this, arguments);
        }
        return getInspectionResultsByDate;
      }()
    }, {
      key: "getInspectionResultsByType",
      value: function () {
        var _getInspectionResultsByType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(t) {
          return _regeneratorRuntime.wrap(function _callee14$(_context14) {
            while (1) switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", this.invokeArcadeAction("GetInspectionResultsByType", t));
              case 1:
              case "end":
                return _context14.stop();
            }
          }, _callee14, this);
        }));
        function getInspectionResultsByType(_x17) {
          return _getInspectionResultsByType.apply(this, arguments);
        }
        return getInspectionResultsByType;
      }()
    }, {
      key: "getInspectionResultsByLink",
      value: function () {
        var _getInspectionResultsByLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(t) {
          return _regeneratorRuntime.wrap(function _callee15$(_context15) {
            while (1) switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", this.invokeArcadeAction("GetInspectionResultsByLink", t));
              case 1:
              case "end":
                return _context15.stop();
            }
          }, _callee15, this);
        }));
        function getInspectionResultsByLink(_x18) {
          return _getInspectionResultsByLink.apply(this, arguments);
        }
        return getInspectionResultsByLink;
      }()
    }, {
      key: "getInspectionResultsByPassed",
      value: function () {
        var _getInspectionResultsByPassed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(t) {
          return _regeneratorRuntime.wrap(function _callee16$(_context16) {
            while (1) switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt("return", this.invokeArcadeAction("GetInspectionResultsByPassed", t));
              case 1:
              case "end":
                return _context16.stop();
            }
          }, _callee16, this);
        }));
        function getInspectionResultsByPassed(_x19) {
          return _getInspectionResultsByPassed.apply(this, arguments);
        }
        return getInspectionResultsByPassed;
      }()
    }, {
      key: "getInspectedLinks",
      value: function () {
        var _getInspectedLinks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(t) {
          return _regeneratorRuntime.wrap(function _callee17$(_context17) {
            while (1) switch (_context17.prev = _context17.next) {
              case 0:
                return _context17.abrupt("return", this.invokeArcadeAction("GetInspectedLinks", t));
              case 1:
              case "end":
                return _context17.stop();
            }
          }, _callee17, this);
        }));
        function getInspectedLinks(_x20) {
          return _getInspectedLinks.apply(this, arguments);
        }
        return getInspectedLinks;
      }()
    }, {
      key: "getUninspectedLinks",
      value: function () {
        var _getUninspectedLinks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(t) {
          return _regeneratorRuntime.wrap(function _callee18$(_context18) {
            while (1) switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", this.invokeArcadeAction("GetUninspectedLinks", t));
              case 1:
              case "end":
                return _context18.stop();
            }
          }, _callee18, this);
        }));
        function getUninspectedLinks(_x21) {
          return _getUninspectedLinks.apply(this, arguments);
        }
        return getUninspectedLinks;
      }()
    }, {
      key: "getGameById",
      value: function () {
        var _getGameById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(t) {
          return _regeneratorRuntime.wrap(function _callee19$(_context19) {
            while (1) switch (_context19.prev = _context19.next) {
              case 0:
                return _context19.abrupt("return", this.invokeArcadeAction("GetGameById", t));
              case 1:
              case "end":
                return _context19.stop();
            }
          }, _callee19, this);
        }));
        function getGameById(_x22) {
          return _getGameById.apply(this, arguments);
        }
        return getGameById;
      }()
    }, {
      key: "getGamesByName",
      value: function () {
        var _getGamesByName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(t) {
          return _regeneratorRuntime.wrap(function _callee20$(_context20) {
            while (1) switch (_context20.prev = _context20.next) {
              case 0:
                return _context20.abrupt("return", this.invokeArcadeAction("GetGamesByName", t));
              case 1:
              case "end":
                return _context20.stop();
            }
          }, _callee20, this);
        }));
        function getGamesByName(_x23) {
          return _getGamesByName.apply(this, arguments);
        }
        return getGamesByName;
      }()
    }, {
      key: "getAllActions",
      value: function () {
        var _getAllActions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
          return _regeneratorRuntime.wrap(function _callee21$(_context21) {
            while (1) switch (_context21.prev = _context21.next) {
              case 0:
                return _context21.abrupt("return", this.invokeArcadeAction("GetAllActions"));
              case 1:
              case "end":
                return _context21.stop();
            }
          }, _callee21, this);
        }));
        function getAllActions() {
          return _getAllActions.apply(this, arguments);
        }
        return getAllActions;
      }()
    }, {
      key: "getGameFilteringMetaData",
      value: function () {
        var _getGameFilteringMetaData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
          return _regeneratorRuntime.wrap(function _callee22$(_context22) {
            while (1) switch (_context22.prev = _context22.next) {
              case 0:
                return _context22.abrupt("return", this.invokeArcadeAction("GetGameFilteringMetaData"));
              case 1:
              case "end":
                return _context22.stop();
            }
          }, _callee22, this);
        }));
        function getGameFilteringMetaData() {
          return _getGameFilteringMetaData.apply(this, arguments);
        }
        return getGameFilteringMetaData;
      }()
    }, {
      key: "getGamesByTypesAndProvider",
      value: function () {
        var _getGamesByTypesAndProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(t) {
          return _regeneratorRuntime.wrap(function _callee23$(_context23) {
            while (1) switch (_context23.prev = _context23.next) {
              case 0:
                return _context23.abrupt("return", this.invokeArcadeAction("GetGamesByTypesAndProvider", t));
              case 1:
              case "end":
                return _context23.stop();
            }
          }, _callee23, this);
        }));
        function getGamesByTypesAndProvider(_x24) {
          return _getGamesByTypesAndProvider.apply(this, arguments);
        }
        return getGamesByTypesAndProvider;
      }()
    }, {
      key: "getGames",
      value: function () {
        var _getGames = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
          var t,
            _args24 = arguments;
          return _regeneratorRuntime.wrap(function _callee24$(_context24) {
            while (1) switch (_context24.prev = _context24.next) {
              case 0:
                t = _args24.length > 0 && _args24[0] !== undefined ? _args24[0] : {};
                return _context24.abrupt("return", this.invokeArcadeAction("GetGames", t));
              case 2:
              case "end":
                return _context24.stop();
            }
          }, _callee24, this);
        }));
        function getGames() {
          return _getGames.apply(this, arguments);
        }
        return getGames;
      }()
    }, {
      key: "getManual",
      value: function () {
        var _getManual = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(t) {
          return _regeneratorRuntime.wrap(function _callee25$(_context25) {
            while (1) switch (_context25.prev = _context25.next) {
              case 0:
                return _context25.abrupt("return", this.invokeArcadeAction("Manual", t));
              case 1:
              case "end":
                return _context25.stop();
            }
          }, _callee25, this);
        }));
        function getManual(_x25) {
          return _getManual.apply(this, arguments);
        }
        return getManual;
      }()
    }, {
      key: "invokeArcadeAction",
      value: function () {
        var _invokeArcadeAction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(t, e) {
          var _this5 = this;
          return _regeneratorRuntime.wrap(function _callee27$(_context27) {
            while (1) switch (_context27.prev = _context27.next) {
              case 0:
                return _context27.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(n, i) {
                    var r, a, s, o, _c, u, h;
                    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
                      while (1) switch (_context26.prev = _context26.next) {
                        case 0:
                          _context26.next = 2;
                          return _this5.ensureAuthentication(i);
                        case 2:
                          a = {
                            "Content-Type": "application/json",
                            Authorization: "".concat(_this5.fAuthenticationData.token_type, " ").concat(_this5.fAuthenticationData.access_token)
                          }, s = {
                            action: t,
                            data: e
                          };
                          e && void 0 !== e.ignoreCache && (s.ignoreCache = e.ignoreCache, s.data.ignoreCache = void 0);
                          o = _this5.post(null !== (r = _this5.fConfigurationData.ARCADE_API_PATH) && void 0 !== r ? r : "", JSON.stringify(s), a);
                          o.catch(i);
                          _context26.next = 8;
                          return o;
                        case 8:
                          _c = _context26.sent;
                          _context26.next = 11;
                          return _c.text();
                        case 11:
                          u = _context26.sent;
                          h = null;
                          try {
                            h = JSON.parse(u);
                          } catch (t) {
                            i(new Error("".concat(t, "\n\nResponse text: ").concat(u)));
                          }
                          n(h);
                        case 15:
                        case "end":
                          return _context26.stop();
                      }
                    }, _callee26);
                  }));
                  return function (_x28, _x29) {
                    return _ref5.apply(this, arguments);
                  };
                }()));
              case 1:
              case "end":
                return _context27.stop();
            }
          }, _callee27);
        }));
        function invokeArcadeAction(_x26, _x27) {
          return _invokeArcadeAction.apply(this, arguments);
        }
        return invokeArcadeAction;
      }()
    }, {
      key: "getPayloadForAction",
      value: function getPayloadForAction(t, e) {
        var n;
        var i = {
            "Content-Type": "application/json",
            Authorization: "".concat(this.fAuthenticationData.token_type, " ").concat(this.fAuthenticationData.access_token.substring(0, 20), "...")
          },
          r = {
            action: t,
            data: e
          };
        return e.ignoreCache && (r.ignoreCache = e.ignoreCache, delete r.data.ignoreCache), ["POST ".concat(this.fConfigurationData.ARCADE_SERVER).concat((n = this.fConfigurationData.ARCADE_API_PATH, null != n ? n : ""), "\n"), "Headers: ".concat(JSON.stringify(i, null, 2)), "", "Payload for the Arcade: " + JSON.stringify(r, null, 2), "Example connector call: connector.invokeArcadeAction('".concat(t, "', ").concat(JSON.stringify(e, null, 2), ").then(console.log)")].join("\n");
      }
    }]);
  }(o);
  var u = /*#__PURE__*/function (_c2) {
    function u() {
      _classCallCheck(this, u);
      return _callSuper(this, u, arguments);
    }
    _inherits(u, _c2);
    return _createClass(u);
  }(c);
  n.d(e, "Connector", function () {
    return u;
  });
},, function (t, e) {
  t.exports = require("stream");
}, function (t, e) {
  t.exports = require("http");
}, function (t, e) {
  t.exports = require("url");
}, function (t, e) {
  t.exports = require("https");
}, function (t, e) {
  t.exports = require("zlib");
}]));